import axios from "../../axios/index";

export const type_projectServices = {
    getAll
}

async function getAll () {
    return await axios.get(`type_projet`);
}